export const SocialData = [
    {
        Platform: "Instagram",
        Link: "https://instagram.com/apoorv.js",
        Icon: "../Assets/instagram.png"
    },
    {
        Platform: "Linkdln",
        Link: "https://www.linkedin.com/in/apoorv-sharma-803998248/",
        Icon: "../Assets/linkdin.png"
    },
    {
        Platform: "Twitter",
        Link: "https://twitter.com/ApoorvJs",
        Icon: "../Assets/twitter.png"
    },
    {
        Platform: "Github",
        Link: "https://github.com/Apoorv266",
        Icon: ("../Assets/github.png")
    }
]

export default SocialData
